import DatePicker from '@components/atoms/DatePicker/DatePicker'

const DatePickerField = ({ ...props }) => {
  return <DatePicker {...props} />
}

export default DatePickerField
